// extracted by mini-css-extract-plugin
export var altaccent = "AccordionPanel-module--altaccent--8ea58";
export var button = "AccordionPanel-module--button--f9acb";
export var heading = "AccordionPanel-module--heading--ec0c5";
export var headline = "AccordionPanel-module--headline--df7ea";
export var intro = "AccordionPanel-module--intro--e548e";
export var item = "AccordionPanel-module--item--3d3e9";
export var itemPanel = "AccordionPanel-module--itemPanel--62e8d";
export var list = "AccordionPanel-module--list--8a93d";
export var panel = "AccordionPanel-module--panel--b8f34";